import { useEffect, useState } from "react";
import MobileList from "../../ui/MobileList";
import MobileListItem from "../../ui/MobileListItem";
import MobileSkeleton from "../../ui/MobileSkeleton";
import MobileEmpty from "../../ui/MobileEmpty";
import MobileError from "../../ui/MobileError";
import { useStoresSearch } from "./useStoresSearch";
import { MobileCreateStoreSheet, MobileStoreDetailSheet } from "./MobileStoreSheets";

function storeSubtitle(store) {
  const parts = [store?.city, store?.state].filter(Boolean);
  if (store?.active) parts.push("Ativa");
  if (store?.headquarter) parts.push("HQ");
  return parts.join(" · ");
}

export default function MobileStoresList({ user }) {
  const { stores, loading, error, search, refresh } = useStoresSearch(user);
  const [createOpen, setCreateOpen] = useState(false);
  const [selectedStore, setSelectedStore] = useState(null);
  const [detailOpen, setDetailOpen] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);

  useEffect(() => {
    setHasSearched(true);
    search();
  }, [search]);

  const handleSearch = () => {
    setHasSearched(true);
    search();
  };

  const openDetail = (store) => {
    setSelectedStore(store);
    setDetailOpen(true);
  };

  const closeDetail = () => {
    setDetailOpen(false);
    setSelectedStore(null);
  };

  const handleCreated = () => {
    setCreateOpen(false);
    setHasSearched(true);
    refresh();
  };

  const handleStoreChanged = () => {
    closeDetail();
    refresh();
  };

  return (
    <div className="flex flex-col">
      <div className="flex items-center gap-2 border-b border-primary/30 bg-mgs-bg px-4 py-2">
        <button
          type="button"
          onClick={() => setCreateOpen(true)}
          className="inline-flex min-h-[44px] items-center justify-center rounded-lg bg-primary px-3 text-sm font-medium text-mgs-bg hover:bg-[#b47c06]"
        >
          Cadastrar loja
        </button>
        <button
          type="button"
          onClick={handleSearch}
          className="inline-flex min-h-[44px] items-center justify-center rounded-lg bg-primary px-3 text-sm font-medium text-mgs-bg hover:bg-[#b47c06]"
        >
          Pesquisar lojas
        </button>
        <button
          type="button"
          onClick={() => {
            setHasSearched(true);
            refresh();
          }}
          className="inline-flex min-h-[44px] items-center justify-center rounded-lg border border-primary/50 px-3 text-sm font-medium text-laranjinha/80 hover:bg-monao"
        >
          Atualizar
        </button>
      </div>

      {loading ? (
        <div aria-label="Carregando lojas" role="status">
          <MobileSkeleton lines={5} />
        </div>
      ) : error ? (
        <MobileError
          message={error.message ?? "Erro ao buscar lojas."}
          onRetry={refresh}
        />
      ) : hasSearched && stores.length === 0 ? (
        <MobileEmpty
          title="Nenhuma loja encontrada"
          message="Toque em Pesquisar lojas para carregar a lista."
        />
      ) : stores.length > 0 ? (
        <MobileList>
          {stores.map((item) => (
            <MobileListItem
              key={item._id}
              title={item.name ?? "Sem nome"}
              subtitle={storeSubtitle(item)}
              onClick={() => openDetail(item)}
            />
          ))}
        </MobileList>
      ) : null}

      <MobileCreateStoreSheet
        open={createOpen}
        onClose={() => setCreateOpen(false)}
        user={user}
        onCreated={handleCreated}
      />

      <MobileStoreDetailSheet
        open={detailOpen}
        onClose={closeDetail}
        store={selectedStore}
        user={user}
        onChanged={handleStoreChanged}
      />
    </div>
  );
}
